<template>
  <m-form
    :title="isDialog ? null : 'تعریف > ' + title"
    :items="items"
    :showList="showList"
    :cols="cols"
    :show-clear-btn="!isDialog"
    :canSubmit="canSubmit"
    list-export-base-url="reports/lists/wares"
    :list_filters="{level: level, is_service: $route.name == 'Services'}"
    :exportParams="{id: item.id}"
    :canDelete="canDelete"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
  >
    <template #header-btns v-if="!isDialog">
      <template v-for="i in 3">
        <v-btn
          :key="i"
          v-if="i - 1 != level"
          depressed
          class="secondary white--text mr-1 mt-2 rounded-lg"
          :to="{ name: isService ? 'Services' : 'Wares', params: { level: i - 1 } }"
        >
          {{ getWareTitle(i - 1) }}
        </v-btn>
        <v-btn :key="i" v-else depressed class="primary white--text mr-1 mt-2 rounded-lg" @click="clearForm">
          {{ getWareTitle(i - 1) }}
        </v-btn>
      </template>
      <v-btn
        v-if="level != 3"
        depressed
        class="secondary white--text ml-3 mr-1 mt-2 rounded-lg"
        :to="{ name: isService ? 'Services' : 'Wares', params: { level: 3 } }"
      >
        {{ getWareTitle(3) }}
      </v-btn>
      <v-btn v-if="level == 3" depressed class="primary white--text ml-3 mr-1 mt-2 rounded-lg" @click="clearForm">
        {{ getWareTitle(3) }}
      </v-btn>
    </template>

    <template #default>
      <v-row>
        <v-col cols="12" md="6" v-if="level != 0">
          <div id="ware-form-parent">
            <v-autocomplete
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :return-object="true"
              :label="' * ' + getWareTitle(level - 1)"
              :items="parentItems"
              v-model="item.parent"
              item-text="name"
              :disabled="item.id != undefined || !isEditing"
              item-value="id"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col cols="12" :md="level == 0 ? 12 : 6">
          <div id="ware-form-code">
            <v-text-field class="rounded-lg" label="کد" v-model="item.code" disabled />
          </div>
        </v-col>
        <v-col cols="12" :md="isWare ? 6 : 12">
          <div id="ware-form-name">
            <v-text-field
              class="rounded-lg"
              label=" * نام"
              :style="{ 'text-align': activeAlignment }"
              v-model="item.name"
              :disabled="!isEditing"
            />
          </div>
        </v-col>
        <v-col cols="12" md="6" v-if="isWare">
          <div id="ware-form-iran-code">
            <v-text-field class="rounded-lg" label="ایران کد" v-model="item.iran_code" :disabled="!isEditing" />
          </div>
        </v-col>
        <v-card width="100%" class="rounded-lg tableHeader secondary--text pl-4 pb-4 pr-4" v-if="isWare">
          <v-card-title style="font-size: medium">
            <v-img class="ml-2" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            اطلاعات مربوط به سامانه مودیان
          </v-card-title>
          <v-row>
            <v-col cols="12" md="12">
              <div id="ware-form-send-exclusive">
                <v-autocomplete
                  label="نحوه ارسال به مودیان "
                  v-model="item.send_exclusive"
                  :items="MOADIAN_SEND_TYPES"
                  class="rounded-lg"
                  item-text="name"
                  item-value="value"
                  :disabled="!isEditing"
                >
                </v-autocomplete>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" v-if="isWare && isEditing">
              <cleave-base-ware
                :is-service="isService"
                :first_item="item.base_ware"
                v-model="item.base_ware"
                :disabled="!isEditing"
              ></cleave-base-ware>
            </v-col>
          </v-row>
          <template v-if="isWare && !isEditing">
            <v-row>
              <v-col cols="12" md="6">
                <div id="base-ware-name">
                  <v-text-field
                    class="rounded-lg"
                    :label="`نام عمومی ${title}`"
                    v-model="item.base_ware_title"
                    disabled
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div id="base-ware-type">
                  <v-text-field class="rounded-lg" label="نوع" v-model="item.base_ware_type" disabled></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div id="base-ware-code">
                  <v-text-field
                    class="rounded-lg"
                    :label="`شناسه عمومی ${title}`"
                    v-model="item.base_ware_code"
                    disabled
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div id="base-ware-value-add-tax">
                  <v-text-field
                    class="rounded-lg"
                    label="نرخ مالیات ارزش افزوده"
                    v-model="item.base_ware_value_added_tax"
                    disabled
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <v-col cols="12" md="6">
              <div id="ware-form-exclusive-name">
                <v-text-field
                  class="rounded-lg"
                  :label="`نام اختصاصی ${title}`"
                  v-model="item.exclusive_name"
                  :disabled="!isEditing"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div id="ware-form-exclusive-code">
                <v-text-field
                  v-on:keypress="exclusiveIdKeyPress"
                  ref="exclusive-id-field"
                  :rules="[rules.exclusive_id_len]"
                  class="rounded-lg"
                  :label="`شناسه اختصاصی ${title}`"
                  v-model="item.exclusive_id"
                  :disabled="!isEditing"
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <template v-if="isWare">
          <v-col cols="12" md="4">
            <div id="ware-form-check-inventory">
              <v-switch
                inset
                v-if="isAdvari"
                :disabled="!isEditing"
                label="موجودی کالای منفی"
                v-model="item.check_inventory"
                :false-value="true"
                :true-value="false"
              ></v-switch>
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <div id="ware-form-sale-price-btn">
              <v-btn @click="pricesDialog = true" block class="mt-1 rounded-lg" depressed color="secondary white--text">
                واحد و قیمت فروش
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="6" v-if="!isService">
            <div id="ware-form-pricing-type">
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                class="rounded-lg"
                label=" * نوع قیمت گذاری"
                :items="pricingTypes"
                v-model="item.pricingType"
                item-text="name"
                item-value="id"
                :disabled="!isEditing || !hasFeature('FIFO_INVENTORY')"
                :return-object="true"
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" md="3" v-if="!isService">
            <div id="ware-form-warehouse">
              <v-autocomplete
                :menu-props="{ bottom: true, offsetY: true }"
                class="rounded-lg"
                :return-object="false"
                label=" * انبار پیشفرض"
                :items="warehouses"
                v-model="item.warehouse"
                :disabled="!isEditing"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </div>
          </v-col>
          <v-col cols="12" md="3" v-if="!isService">
            <div id="ware-form-barcode">
              <v-text-field class="rounded-lg" label="بارکد" v-model="item.barcode" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="ware-form-min-sale">
              <money label="حداقل فروش" v-model="item.minSale" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="ware-form-max-sale">
              <money label="حداکثر فروش" v-model="item.maxSale" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="6" v-if="isService">
            <div id="ware-form-explanation">
              <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="ware-form-min-inventory">
              <money v-if="!isService" label="حداقل موجودی" v-model="item.minInventory" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="ware-form-max-inventory">
              <money v-if="!isService" label="حداکثر موجودی" v-model="item.maxInventory" :disabled="!isEditing" />
            </div>
          </v-col>
        </template>
        <v-col cols="12" v-if="!isService">
          <div id="ware-form-explanation">
            <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
          </div>
        </v-col>
      </v-row>

      <v-dialog
        class="rounded-lg pa-2"
        v-model="pricesDialog"
        scrollable
        :width="pricesDialogWidth"
        transition="dialog-transition"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary--text">
            واحد و قیمت فروش
            <span class="pr-1">{{ item.name }}</span>
          </v-card-title>
          <v-card-subtitle class="success--text pt-2"> واحد کالا از کوچک به بزرگ ثبت شود</v-card-subtitle>

          <v-card-text>
            <input-table v-model="rows">
              <template #thead>
                <tr>
                  <th class="secondary--text text-center">ردیف</th>
                  <th id="ware-form-sale-price-unit" class="secondary--text text-center">واحد</th>
                  <th :width="(salePriceTypes.length==0)?'25%':'15%'" id="ware-form-sale-price-conversion-factor"
                      class="secondary--text text-center">
                    ضریب تبدیل</th>
                  <th class="secondary--text text-center"></th>
                  <th class="secondary--text text-center" v-for="salePriceType in salePriceTypes">
                    {{ salePriceType.name }}
                  </th>
                  <th class="secondary--text text-center"></th>
                </tr>
              </template>
              <template #tbody>
                <tr v-for="(row, i) in rows" :key="i">
                  <td class="tr-counter text-center">{{ i + 1 }}</td>
                  <td class="text-center" style="width: 300px">
                    <v-autocomplete
                      class="rounded-lg"
                      :return-object="false"
                      :items="units"
                      v-model="row.unit"
                      item-text="name"
                      item-value="id"
                      :disabled="!isEditing"
                    ></v-autocomplete>
                  </td>
                  <td class="text-center">
                    <span v-if="i == 0" style="font-weight: bold; font-size: smaller" class="secondary--text">واحد پایه</span>
                    <span v-if="i == 0" style="font-size: smaller" class="secondary--text mr-2">(پیشفرض)</span>
                    <money v-else v-model="row.conversion_factor" :disabled="!isEditing" />
                  </td>
                  <td class="text-center">
                    <div v-if="i != 0 && row.unit">
                      <span style="font-size: smaller;" class="secondary--text">
                        هر یک
                        {{unitDisplay(row.unit)}}
                        برابر است با
                      </span>
                      <span v-if="row.conversion_factor"
                            style="font-size: smaller; font-weight: bold" class="secondary--text">
                        {{row.conversion_factor}}
                        {{unitDisplay(rows[0].unit)}}

                      </span>
                    </div>
                  </td>
                  <td v-for="salePriceType in salePriceTypes" style="width: 150px" class="text-center">
                    <money :disabled="!isEditing" v-model="row.prices[salePriceType.id]" />
                  </td>
                  <td class="d-print-none text-center">
                    <v-btn
                      v-if="i != rows.length - 1"
                      @click="deleteRow(i)"
                      class="error--text"
                      icon
                      :disabled="!isEditing"
                    >
                      <v-img class="" max-width="20" src="/img/icons/delete.svg"></v-img>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </input-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="pricesDialog = false" class="rounded-lg" color="success white--text w-100px"
              >تایید
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </m-form>
</template>
<script>
import WareApiMixin from "@/mixin/wareApi";
import { MFormMixin } from "@/components/m-form";
import CleaveBaseWare from "@/components/scomponents/BaseWareSelect";

export default {
  name: "Wares",
  components: { CleaveBaseWare },
  mixins: [MFormMixin, WareApiMixin],
  props: {
    level: {
      requried: true,
    },
    isService: {
      default: false,
    },
    showList: {
      default: true,
    },
    isDialog: {
      default: false,
    },
  },
  data() {
    return {
      activeAlignment: "center",
      item: {},
      baseUrl: "wares/wares",
      permissionBasename: "ware",
      rowKey: "unit",
      pricesDialog: false,
      cols: [
        {
          text: "کد",
          value: "code",
        },
        {
          text: "نام",
          value: "name",
        },
        {
          text: "ایران کد",
          value: "iran_code",
        },
      ],
      MOADIAN_SEND_TYPES: [
        { name: "ارسال با نام و شناسه عمومی", value: false },
        { name: "ارسال با نام و شناسه اختصاصی", value: true },
      ],
      rules: {
        exclusive_id_len: value => value.length == 13 || !value,
      },

    };
  },
  computed: {
    pricesDialogWidth(){
      let dialog_width = 900
      for (let salePriceType in this.salePriceTypes){
        dialog_width += 200
      }
      return dialog_width
    },
    title() {
      return this.setDocumentTitle(this.getWareTitle(this.level));
    },
    isWare() {
      return this.level == 3;
    },
    parentItems() {
      return this.wares.filter((o) => o.level == +this.level - 1 && o.is_service == this.isService);
    },
    items() {
      return this.wares.filter((o) => {
        return o.level == this.level && o.is_service == this.isService;
      });
    },
    parents() {
      let parent = this.item.parent;
      let parents = [];
      let parentId = false;
      if (typeof parent == typeof 72) {
        parentId = parent;
      } else if (parent && parent.id) {
        parentId = parent.id;
      }
      while (parentId) {
        let parent = this.wares.filter((o) => o.id == parentId)[0];
        parents.push(parent.name);
        parentId = parent.parent;
      }
      return parents.reverse().join(" > ");
    },
  },
  methods: {
    getWareTitle(level) {
      switch (Number(level)) {
        case 0:
          if (this.isService) return "ماهیت خدمت";
          else return "ماهیت کالا";
        case 1:
          if (this.isService) return "گروه خدمت";
          else return "گروه کالا";
        case 2:
          if (this.isService) return "دسته بندی خدمت";
          else return "دسته بندی کالا";
        case 3:
          if (this.isService) return "خدمت";
          else return "کالا";
      }
    },
    getRowTemplate() {
      return {
        unit: null,
        conversion_factor: null,
        prices: {},
      };
    },
    getData() {
      this.getUnits();
      this.getSalePriceTypes();
      this.getWarehouses();
      this.getWares(true);
    },
    unitDisplay(unit_id) {
      for (let unit of this.units){
        if (unit.id == unit_id) {
          return unit.name
        }
      }
    },

    setItem(item) {
      this.request({
        url: this.endpoint(`wares/wares/${item.id}`),
        method: "get",
        success: (data) => {
          item = data;
          if (item.salePrices.length) {
            this.rows = item.salePrices;
          } else {
            this.rows = [this.getRowTemplate()];
          }
          this.item = item;
        },
      });
    },
    getSerialized() {
      let item = this.extractIds(this.item);
      item.level = this.level;
      item.salePrices = this.rows.map((o) => this.extractIds(o));
      item.is_service = this.isService;
      return item;
    },
    getItemTemplate() {
      const template = {
        parent: null,
      };
      if (!this.hasFeature("FIFO_INVENTORY")) {
        template.pricingType = "wm";
      }
      return template;
    },
    exclusiveIdKeyPress(evt) {
      if (this.$refs["exclusive-id-field"].$props.value.length >= 13) {
        evt.preventDefault();
      }
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
